
import React from 'react';
import { mergeStyles, mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Toolbar from './Toolbar';

function getToolbarStyle(position, direction) {
    let style = {
        position: 'absolute',
        zIndex: 100
    };
    switch (position) {
        case 'left':
            if (direction === 'reverse') {
                style.bottom = 0;
            }
            break;
        case 'right':
            style.right = 0;
            if (direction === 'reverse') {
                style.bottom = 0;
            }
            break;
        case 'top':
            if (direction === 'reverse') {
                style.right = 0;
            }
            break;
        case 'bottom':
            style.bottom = 0;
            if (direction === 'reverse') {
                style.right = 0;
            }
            break;
    }
    return mergeStyles(style);
}

const ToolbarWrapper = (props) => {
    return (
        <div className={getToolbarStyle(props.position, props.direction)}>
            <Toolbar
                position={props.position}
                direction={props.direction}
                buttons={props.buttons}
            />
        </div>
    );
}

const ContainerWithToolbars = (props) => {

    const classNames = mergeStyleSets({
        root: {
            position: 'relative',
            height: '100%'
        }
    });

    return (
        <div className={classNames.root}>
            {props.toolbars.map((item, index) => {
                return (
                    <ToolbarWrapper
                        key={index}
                        position={item.position}
                        direction={item.direction}
                        buttons={item.buttons}
                    />
                );
            })}
            {props.children}
        </div>
    )
}

export default ContainerWithToolbars;
